import { Tag } from '@sunwebgroup/uds-ui/tag'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import React from 'react'
import { useIntl } from '@/intl'
import { useBookingDraftQuery } from '@/scopes/checkout/domain/hooks'
import { MediaServerLazyImage } from '@/scopes/common/components/MediaServerLazyImage/MediaServerLazyImage'
import styles from './CheckoutConfirmationHero.module.css'

const HERO_IMAGE_SRCSET_WIDTHS = [375, 600, 720, 1440, 2000, 2400]

function CheckoutConfirmationHero() {
  const intl = useIntl()
  const { data } = useBookingDraftQuery()

  const accommodationName = data?.basketInformation?.accommodationName
  if (!accommodationName) {
    return null
  }

  const countryImageUrl = data?.basketInformation?.countryImageUrl
  const countryName = data?.basketInformation?.countryName
  const bookingNumber = data?.confirmation?.bookingNumber
  const { startDate, endDate } = data?.basketInformation?.bookingPackageDetails?.tripDates ?? {}

  function getDateRange(startDate: Date | undefined, endDate: Date | undefined): string {
    if (!startDate || !endDate) {
      return ''
    }

    return startDate.getMonth() === endDate.getMonth()
      ? `${startDate.toLocaleDateString(intl.locale, { day: 'numeric' })} – ${endDate.toLocaleDateString(intl.locale, { day: 'numeric', month: 'long', year: 'numeric' })}`
      : `${startDate.toLocaleDateString(intl.locale, { day: 'numeric', month: 'long' })} – ${endDate.toLocaleDateString(intl.locale, { day: 'numeric', month: 'long', year: 'numeric' })}`
  }

  return (
    <div className={styles.hero}>
      <MediaServerLazyImage
        className={styles.image}
        src={countryImageUrl ?? ''}
        widths={HERO_IMAGE_SRCSET_WIDTHS}
        alt={countryName ?? ''}
      />
      <div className={styles.card}>
        {bookingNumber && (
          <Tag variant="informative-tinted" size="M">
            {intl.formatMessage({ id: 'common_booking_number_label' }, { bookingNumber })}
          </Tag>
        )}
        <Typography as="h1" variant="display-e-regular" className={styles.title}>
          {accommodationName}
        </Typography>
        <Typography as="p" variant="display-h-regular" className={styles.dates}>
            {getDateRange(startDate, endDate)}
        </Typography>
      </div>
    </div>
  )
}

export default CheckoutConfirmationHero
